module.exports = __webpack_public_path__ + "img/ic-up.aee3a7b0.svg";